export default {
  fundera: 'Fundera',
  lendio: 'Lendio, Inc',
};
